import { createSelector } from '@reduxjs/toolkit';

import { InsightsState } from 'app-redux/InsightsState';
import { AggregationThresholdsSpark } from 'utils/constants';
import { parseDateAsLocal, reverseEngineerTimeframeOptionsFM } from 'utils/dateTimeHelpers';
import { ComputeAggregationCategory } from 'utils/modelHelpers';

const getStartDate = (state: InsightsState) => state.diseaseActivitiesTimeFrame.startDate;
const timeframeStartDateAsDate = createSelector(getStartDate, startDate => parseDateAsLocal(startDate));
const getAggregationCat = createSelector(getStartDate, startDate =>
  ComputeAggregationCategory({
    startDate: parseDateAsLocal(startDate),
    endDate: new Date(),
    thresholds: AggregationThresholdsSpark,
  })
);
const getTimeframe = createSelector(getStartDate, startDate => reverseEngineerTimeframeOptionsFM(startDate).timeframeType);

export default {
  getStartDate,
  getAggregationCat,
  timeframeStartDateAsDate,
  getTimeframe,
};
